import { Dispatch } from "@reduxjs/toolkit";
import { togglePendingWithdraw } from "@tvg/sh-lib-paws/redux/slices/pendingWithdrawSlice";

export const toggleModal = (dispatch: Dispatch, isOpen: boolean) => () =>
  dispatch(togglePendingWithdraw(isOpen));
